import Axios from 'axios'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export const GatewayGet = async (props, input) => {
    var config = {
        method: "post",
        url: props['query'],
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
          "Content-Type": "application/json",
        },
    
        data: {
          Activity: input.Activity,
          Input: input.Input,
        },
      };
      return await Axios(config)
        .then(function (response) {
          if (Object.entries(input).length === 0) {
            return response.data.d;
          } else {
            return JSON.parse(response.data.d["Result"]);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    
}

export const GatewayPost = async (props, input) => {
    return await Axios.post(props['query'], input, props['headers'])

        .then((response) => {
            console.log('Response gateway' + response)
            // This additional condition is added particularly for Manager
            if (
                Object.entries(input).length === 0
                // &&
                // response.data.d["message"] !== "" &&
                // response.data.d["message"] !== undefined
            ) {
                return response.data.d
            } else {
                return JSON.parse(response.data.d['Result'])
            }
        })
        .catch((error) => {
            if (error.response.status === 500) {
                if (
                    sessionStorage.getItem('internalServerError') === null ||
                    JSON.parse(
                        sessionStorage.getItem('internalServerError')
                    ) !== true
                ) {
                    toast.error(
                        'Transportation Management System is either Down or experiencing Technical problem. Please contact Techanical Team'
                    )
                    sessionStorage.setItem('internalServerError', true)

                    setTimeout(() => {
                        window.location.href = '/'
                    }, 5000)
                }
            }
            if (error.response.status === 403) {
                if (
                    sessionStorage.getItem('sessionTimeout') === null ||
                    JSON.parse(sessionStorage.getItem('sessionTimeout')) !==
                        true
                ) {
                    toast.error('Session timed out. Redirecting to home page')
                    sessionStorage.setItem('sessionTimeout', true)

                    setTimeout(() => {
                        window.location.href = '/'
                    }, 5000)
                }
            }
        })
}

export default GatewayGet
